<template>
  <div class="box3-container">
    <div class="title">
      <h3>IP广播</h3>
      <div class="r_block">
        <span></span>
        <em></em>
        <span></span>
      </div>
    </div>
    <div class="content">
      <div id="assetChart" :style="{width: '100%', height: '100%'}"></div>
    </div>
    <div class="bottom">
      <div class="r_block">
        <span></span>
        <em></em>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Box3',
  props: {
    itemData: {
      type: Object,
      required: true, // 默认值是false
      default: function () {
        return {
          total: 0,
          online: 0,
          Offline: 0
        }
      }
    }
  },
  data() {
    return {
      assetData: {
        legend: {
          orient: '',
          x: 'right',
          y: 'bottom',
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: '#fff',
            fontSize: 12,
          }
        },
        series: [
          {
          name: '正常',
          type: 'pie',
          radius: ['45%','61%'],
          center: ['30%','50%'],
          label: {
            alignTo: 'edge',
            normal: {
              position: 'outside',    // 标签的位置。'outside'饼图扇区外侧，通过视觉引导线连到相应的扇区。'inside','inner' 同 'inside',饼图扇区内部。'center'在饼图中心位置。
              formatter: '{text|{b}}\n{value|{c}}{unit|台}',
              rich: {
                text: {
                  fontSize: 10,
                  color: '#fff',
                  padding: 0
                },
                value: {
                  fontSize: 24,
                  color: '#fff',
                  fontFamily: 'Bahnschrift',
                  padding: 5
                },
                unit: {
                  fontSize: 10,
                  color: '#fff'
                }
              }
            },
            
          },
          labelLine: {
            length: -50,  // 在 label 位置 设置为'outside'的时候会显示视觉引导线。
            length2: 110, // 视觉引导项第二段的长度。
          },
          data: [
            {
              name: '正常',
              value: 8,
              itemStyle: {
                color: '#493304'
              }
            }
          ]
        },{
            name: 'IP广播',
            type: 'pie',
            radius: ['60%','80%'],
            center: ['30%','50%'],
            label: {
              alignTo: 'edge',
              normal: {
                position: 'outside',    // 标签的位置。'outside'饼图扇区外侧，通过视觉引导线连到相应的扇区。'inside','inner' 同 'inside',饼图扇区内部。'center'在饼图中心位置。
                formatter: '{text|{b}}\n{value|{c}}{unit|台}',
                rich: {
                  text: {
                    fontSize: 10,
                    color: '#fff',
                    padding: 0
                  },
                  value: {
                    fontSize: 24,
                    color: '#fff',
                    fontFamily: 'Bahnschrift',
                    padding: 5
                  },
                  unit: {
                    fontSize: 10,
                    color: '#fff'
                  }
                }
              },
              
            },
            labelLine: {
              length: 0,  // 在 label 位置 设置为'outside'的时候会显示视觉引导线。
              length2: 15 // 视觉引导项第二段的长度。
            },
            data: [{
                name: '在线设备',
                value: 5,
                itemStyle: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0,
                            color: '#ffd545' // 0% 处的颜色
                        }, {
                            offset: 1,
                            color: '#e2a100' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                    }
                }
            },
            {
                name: '离线设备',
                value: 3,
                itemStyle: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0,
                            color: '#2285eb' // 0% 处的颜色
                        }, {
                            offset: 1,
                            color: '#56cbff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                    }
                }
            }]
        }]

      }
    }
  },
  watch: {
    itemData: {
      handler(newVal, oldVal) {
        if(oldVal){
          if(newVal.online!=oldVal.online||newVal.total!=oldVal.total){
            this.drawChart()
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    drawChart () {
      this.assetData.series[0].data[0].value=this.itemData.total
      this.assetData.series[1].data[0].value=this.itemData.online
      this.assetData.series[1].data[1].value=this.itemData.Offline
      var assetChart = this.$echarts.init(document.getElementById('assetChart'))
      assetChart.clear()
      // 绘制图表
      assetChart.setOption(this.assetData)
    }
  },
  mounted () {
    this.drawChart()
  }
}
</script>
<style lang='less'>
.box3-container {
  width: 100%;
  height: 100%;
  position: relative;
  .title {
    height:48px;
    display: flex;
    align-items: center;
    justify-content: flex-start ;
    width: 100%;
    background-image: url(../../assets/home_images/title_bg.png);
    background-position: 0 center;
    background-repeat: no-repeat;
    position: relative;
    h3{
      font-size: 20px;
      font-weight: normal;
      color: #fff;
      padding-left: 20px;
      margin:0;
      margin-top:5px;
    }
    .r_block{
      position: absolute;
      right:0;
      bottom:9px;
      display: flex;
      align-items: center;
      span{
        width:3px;
        height:7px;
        background: #a37600;
        display: block;
      }
      em{
        width:12px;
        height:7px;
        background: #0d0707;
        display: block;
      }
    }
  }
  .bottom{
    height:4px;
    display: flex;
    align-items: center;
    justify-content: flex-start ;
    width: 100%;
    background-image: url(../../assets/home_images/con_bot.png);
    background-position: 0 center;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0;
    left: 0;
    .r_block{
      position: absolute;
      right:0;
      bottom:0px;
      display: flex;
      align-items: center;
      span{
        width:4px;
        height:4px;
        background: #a37600;
        display: block;
      }
      em{
        width:10px;
        height:4px;
        background: #0d0707;
        display: block;
      }
    }
  }
  .content {
    position: absolute;
    top: 48px;
    bottom: 4px;
    left: 0;
    right:0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-image: url(../../assets/home_images/con_left.png);
    background-position: 0 0;
    background-repeat: no-repeat;
    box-sizing: border-box;
    padding: 10px 20px;
    .video {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
      }
      iframe{
        margin: 0;
        padding: 0;
        border:0;
      }
    }
  }
}
</style>
